import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPhoneNumber',
})
export class FormatPhoneNumberPipe implements PipeTransform {
  transform(countryCode: string, phoneNumber: string): string {
    if (!phoneNumber) return null;
    if (!countryCode) return phoneNumber;

    const phoneNumberWithoutLeadingZero = this.removeLeadingZeros(phoneNumber);

    return !countryCode.startsWith('+')
      ? `+${countryCode} ${phoneNumberWithoutLeadingZero}`
      : `${countryCode} ${phoneNumberWithoutLeadingZero}`;
  }

  private removeLeadingZeros(value: string): string {
    if (!value) return '';
    return value.replace(/^0+/, '');
  }
}
